import { inputClass, labelClass } from "@/components/base/fieldStyles";

interface Option {
  value: string;
  label: string;
}

interface ClientFiltersProps {
  month: string;
  origin: string;
  months: Option[];
  origins: string[];
  resultCount: number;
  onMonth: (value: string) => void;
  onOrigin: (value: string) => void;
  onClear: () => void;
}

// Filtros del módulo de clientes: por mes de compra y por origen de captación.
const ClientFilters = ({
  month,
  origin,
  months,
  origins,
  resultCount,
  onMonth,
  onOrigin,
  onClear,
}: ClientFiltersProps) => {
  const active = Boolean(month || origin);

  return (
    <div className="glass-panel rounded-lg p-4 mb-4">
      <div className="flex flex-col lg:flex-row lg:items-end gap-3">
        <div className="w-full lg:w-56">
          <label className={labelClass}>Mes de compra</label>
          <div className="relative">
            <select
              value={month}
              onChange={(e) => onMonth(e.target.value)}
              className={`${inputClass} appearance-none pr-8`}
              aria-label="Filtrar por mes de compra"
            >
              <option value="" className="bg-background-100">
                Todos los meses
              </option>
              {months.map((m) => (
                <option key={m.value} value={m.value} className="bg-background-100">
                  {m.label}
                </option>
              ))}
            </select>
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-s-line" />
            </span>
          </div>
        </div>

        <div className="w-full lg:w-56">
          <label className={labelClass}>Origen de captación</label>
          <div className="relative">
            <select
              value={origin}
              onChange={(e) => onOrigin(e.target.value)}
              className={`${inputClass} appearance-none pr-8`}
              aria-label="Filtrar por origen de captación"
            >
              <option value="" className="bg-background-100">
                Todos los orígenes
              </option>
              {origins.map((o) => (
                <option key={o} value={o} className="bg-background-100">
                  {o}
                </option>
              ))}
            </select>
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-s-line" />
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3 lg:ml-auto">
          <span className="text-xs text-foreground-600 whitespace-nowrap">
            <strong className="text-foreground-950">{resultCount}</strong> cliente
            {resultCount === 1 ? "" : "s"}
          </span>
          {active && (
            <button
              onClick={onClear}
              className="px-3 py-2 rounded-md border border-accent-500/35 text-accent-200 hover:bg-accent-500/10 text-xs font-semibold whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-1.5"
            >
              <i className="ri-close-line" /> Limpiar filtros
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientFilters;